import React, { useCallback } from "react";
import client from "@culturehq/client";
import { classnames, Button, Icon } from "@culturehq/components";

import { useDelayedCallback } from "app/hooks";

import { Trans } from "app/utils";

const ConnectButton = ({ user, onConnect }) => {
  const handleFollow = useCallback(
    async () => {
      await client.createUserConnection({ userId: user.id });
      onConnect();
    },
    [onConnect, user]
  );

  const [followed, onFollow] = useDelayedCallback(2000, handleFollow);

  return (
    <span className={classnames("add-tag", { "add-tag-anim": followed })}>
      <Button onClick={onFollow} className="pull-right">
        <Trans>Follow</Trans>
      </Button>
      {followed && (
        <>
          <span className="add-tag--circle add-tag--circle-white" />
          <span className="add-tag--check add-tag--check-white">
            <Icon icon="checkmark" />
          </span>
        </>
      )}
    </span>
  );
};

export default ConnectButton;
